// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-lock-closed
 * @tagname hzn-icon-lock-closed
 * @summary An individual icon for Horizon
 */
export class HznIconLockClosed extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10 7.5C10 6.39543 10.8954 5.5 12 5.5C13.1046 5.5 14 6.39543 14 7.5V8.5H10V7.5ZM8 8.5V7.5C8 5.29086 9.79086 3.5 12 3.5C14.2091 3.5 16 5.29086 16 7.5V8.5H17C18.1046 8.5 19 9.39543 19 10.5V18.5C19 19.6046 18.1046 20.5 17 20.5H7C5.89543 20.5 5 19.6046 5 18.5V10.5C5 9.39543 5.89543 8.5 7 8.5H8ZM15 10.5H9H7V18.5H17V10.5H15Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=lock-closed.js.map